import { type SourcingHiringGoalWithMetrics } from 'api-clients/monolith';

import { cn } from '@/utils/classnames';

import { AggregateHiresControls } from '../aggregate-hires-controls';
import { HiringGoalDateRange } from './date-range';
import { HiringGoalHires } from './hires';
import { NoActiveHiringGoal } from './no-active';

interface HiringGoalViewProps {
  hiringGoal: SourcingHiringGoalWithMetrics | null;
  hiringGoalEditUrl: string;
  onViewPastGoals: () => void;
  hasMultipleActiveGoals?: boolean;
  /** True while switching back to this tab is still being fetched. */
  isPending?: boolean;
}

function Divider() {
  return <div className="bg-fx-neutral-200 w-px self-stretch" aria-hidden />;
}

export function HiringGoalView({
  hiringGoal,
  hiringGoalEditUrl,
  onViewPastGoals,
  hasMultipleActiveGoals,
  isPending,
}: HiringGoalViewProps) {
  if (!hiringGoal?.external_id) {
    return (
      <NoActiveHiringGoal
        addHiringGoalUrl={hiringGoalEditUrl}
        onViewPastGoals={onViewPastGoals}
      />
    );
  }

  return (
    <div className="flex min-h-[80px] items-start gap-6">
      <HiringGoalDateRange
        startDate={hiringGoal.start_date}
        endDate={hiringGoal.hire_by}
        daysElapsed={hiringGoal.days_elapsed}
        addEndDateUrl={hiringGoalEditUrl}
      />

      <Divider />

      <div
        className={cn(
          'flex min-w-0 flex-1 flex-col gap-1 transition-opacity',
          isPending && 'opacity-30',
        )}
      >
        <HiringGoalHires
          actual={hiringGoal.hire_stats.actual.total}
          expected={hiringGoal.hire_stats.expected}
          onViewPastGoals={onViewPastGoals}
          hasMultipleActiveGoals={hasMultipleActiveGoals}
        />
        <AggregateHiresControls />
      </div>
    </div>
  );
}
